import React from "react";
import Link from "next/link";

import { Brand } from "custom-types/Brand";

import Image from "components/Image";

type Props = {
  brand: Brand;
  disableLazyLoad?: boolean;
  onClick?: () => void;
};

const BrandCoin: React.FC<Props> = ({ brand, disableLazyLoad, onClick }) => {
  return (
    <Link href={`/brands/${brand.slug}`} className="block" onClick={onClick}>
      <div
        className="rounded-full elevation-low overflow-hidden mb-lg"
        style={{ height: "80px", isolation: "isolate", width: "80px" }}
      >
        <Image
          alt={`${brand.name} logo`}
          disableLazyLoad={disableLazyLoad}
          ratio="square"
          sizes={[80]}
          src={brand.logo}
        />
      </div>
      <div className="px-0.5 max-w-[80px] text-xs font-bold text-center text-green underline break-words">
        {brand.name}
      </div>
    </Link>
  );
};

export default BrandCoin;
